import axios from 'axios';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function EditQuestion() {
  const navigate = useNavigate();
  const server_url = process.env.REACT_APP_API_URI;
  const location = useLocation();
  const { catId, questionId } = location.state;
  const [question, setQuestionData] = useState(null);
  const [updatedQuestion, setUpdatedQuestion] = useState({
    question: '',
    description: '',
  });
  const [message, setMessage] = useState('');

  useEffect(() => {
    const getQuestionById = async () => {
      try {
        const response = await axios.post(
          `${server_url}/question/get-question`,
          JSON.stringify(location.state),
          { headers: { 'Content-Type': 'application/json' } },
        );
        setQuestionData(response.data);
      } catch (err) {
        console.error('Error fetching question:', err);
      }
    };
    getQuestionById();
  }, [catId, server_url, location.state]);

  const updateQuestionForm = (value) => {
    setUpdatedQuestion((prev) => ({ ...prev, ...value }));
  };

  const handleQuestionFormSubmit = async (e) => {
    e.preventDefault();
    const updatedQuestionDetail = { ...updatedQuestion, catId, questionId };
    try {
      const response = await axios.put(
        `${server_url}/question/update-question`,
        JSON.stringify(updatedQuestionDetail),
        { headers: { 'Content-Type': 'application/json' } },
      );
      setMessage(response.data.msg);
      setTimeout(() => navigate('/admin/questions'), 2000);
    } catch (err) {
      console.error('Error updating question:', err);
      setMessage('Failed to update question. Please try again.');
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-6 bg-white rounded-2xl shadow-lg">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-semibold text-gray-800">Edit Question</h1>
        <button
          onClick={() => navigate('/admin/questions')}
          className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition duration-200"
        >
          Back
        </button>
      </div>

      {message && (
        <div className="mb-4 text-sm font-medium px-4 py-2 rounded bg-green-100 text-green-700 ">
          {message}
        </div>
      )}

      {question && (
        <div className="bg-gray-100 p-4 rounded-xl mb-6">
          <div className="mb-2 text-lg font-medium text-gray-700">
            <span className="text-gray-600 font-semibold">
              Current Question:
            </span>{' '}
            {question.question}
          </div>
          <div className="mb-2 text-lg font-medium text-gray-700">
            <span className="text-gray-600 font-semibold">
              Current Search Key:
            </span>{' '}
            {question.searchKey}
          </div>
          <div className="mb-2 text-lg font-medium text-gray-700">
            <span className="text-gray-600 font-semibold">
              Current Description:
            </span>{' '}
            {question.description || 'No Description'}
          </div>
          {/* <div className="text-gray-600">
            <span className="font-semibold">ID:</span> {question._id}
          </div> */}
        </div>
      )}

      <form className="space-y-6" onSubmit={handleQuestionFormSubmit}>
        <div>
          <label className="block text-gray-700 font-medium mb-2">
            Question Name
          </label>
          <input
            type="text"
            className="w-full px-4 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder={question?.question || 'Enter question name'}
            onChange={(e) => updateQuestionForm({ question: e.target.value })}
            value={updatedQuestion.question}
            required
            minLength={3}
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-2">
            Search Key
          </label>
          <input
            type="text"
            className="w-full px-4 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder={question?.searchKey || 'Enter question name'}
            onChange={(e) => updateQuestionForm({ searchKey: e.target.value })}
            value={updatedQuestion.searchKey}
            required
            minLength={1}
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-2">
            Question Description
          </label>
          <textarea
            className="w-full px-4 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder={question?.description || 'Enter question description'}
            onChange={(e) =>
              updateQuestionForm({ description: e.target.value })
            }
            value={updatedQuestion.description}
            rows={4}
            minLength={0}
          ></textarea>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className="px-6 py-2 bg-blue-600 text-white font-medium rounded-xl hover:bg-blue-700 transition duration-200"
          >
            Update
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditQuestion;
